import React, { Fragment, useState } from 'react'
import { FormControl, Typography, FilledInput } from '@material-ui/core'
import useStyles from './styles'

const PinInput = ({ phone, onChange }) => {
  const classes = useStyles()

  const [pin, setPin] = useState('')
  const [focused, setfocused] = useState(false)

  const handlePinChange = e => {
    const value = e.currentTarget.value
    if (value.length <= 4) {
      setPin(value)
    }
    if (value.length === 4) {
      onChange(value)
    }
    if (value.length < 4) {
      onChange('')
    }
  }

  const handleFocus = () => {
    setfocused(true)
  }

  const handleBlur = () => {
    setfocused(false)
  }

  return (
    <Fragment>
      <Typography variant="caption">
        Pin number has been sent to <strong>{phone}</strong> enter it below to
        login
      </Typography>
      <div className={classes.pinInputWrapper}>
        <input
          className={classes.hiddenInput}
          value={pin}
          onChange={handlePinChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          type="tel"
          autoFocus
        />
        <FormControl fullWidth className={classes.pinInput}>
          {focused && pin.length === 0 && (
            <span className="blinking-cursor">|</span>
          )}
          <FilledInput
            type="text"
            fullWidth
            inputProps={{
              required: true,
              className: classes.pinInputInput
            }}
            name="0"
            value={pin[0] || ''}
            id="pinInput0"
            autoComplete="nope"
          />
        </FormControl>
        <FormControl fullWidth className={classes.pinInput}>
          {focused && pin.length === 1 && (
            <span className="blinking-cursor">|</span>
          )}
          <FilledInput
            type="text"
            fullWidth
            inputProps={{
              required: true,
              className: classes.pinInputInput
            }}
            name="1"
            value={pin[1] || ''}
            id="pinInput1"
            autoComplete="nope"
          />
        </FormControl>
        <FormControl fullWidth className={classes.pinInput}>
          {focused && pin.length === 2 && (
            <span className="blinking-cursor">|</span>
          )}
          <FilledInput
            type="text"
            fullWidth
            inputProps={{
              required: true,
              className: classes.pinInputInput
            }}
            name="2"
            value={pin[2] || ''}
            id="pinInput2"
            autoComplete="nope"
          />
        </FormControl>
        <FormControl fullWidth className={classes.pinInput}>
          {focused && pin.length === 3 && (
            <span className="blinking-cursor">|</span>
          )}
          <FilledInput
            type="text"
            fullWidth
            inputProps={{
              required: true,
              className: classes.pinInputInput
            }}
            name="3"
            value={pin[3] || ''}
            id="pinInput3"
            autoComplete="nope"
          />
        </FormControl>
      </div>
    </Fragment>
  )
}

export default PinInput



// WEBPACK FOOTER //
// ./src/components/LoginForm/PinInput/index.jsx